import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Plus } from "lucide-react";
import { getVisibleQuickCreateActions } from "./mobileNavConfig";
import TaskRegisterModal from "../../modules/hrm/tasks/components/TaskRegisterModal";
import OnLeaveCreateModal from "../../modules/hrm/onLeave/OnLeaveCreateModalNew";
import OverTimeCreateModal from "../../modules/hrm/overtime/OverTimeCreateModal";
import BusinessTripCreateModal from "../../modules/hrm/businessTrip/BusinessTripCreateModal";
import AttendanceLogCreateModal from "../../modules/hrm/attendance/AttendanceLogCreateModal";

export default function QuickCreateSheet({ open, onClose }) {
  const actions = getVisibleQuickCreateActions();
  const [createKind, setCreateKind] = useState(null);

  const closeCreate = () => setCreateKind(null);

  const handleSelect = (actionId) => {
    onClose();
    // Đợi sheet đóng xong rồi mở form (tránh chồng overlay)
    window.setTimeout(() => setCreateKind(actionId), 180);
  };

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[100] flex flex-col justify-end bg-black/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          >
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 28, stiffness: 320 }}
              className="max-h-[70vh] overflow-hidden rounded-t-[1.5rem] bg-white shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="border-b border-gray-100 px-5 pt-4 pb-3">
                <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-gray-200" />
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-50 text-red-700">
                      <Plus size={18} strokeWidth={2.5} />
                    </div>
                    <h3 className="text-sm font-black uppercase tracking-wider text-gray-800">
                      Tạo nhanh
                    </h3>
                  </div>
                  <button
                    type="button"
                    onClick={onClose}
                    className="rounded-xl p-2 text-gray-500 hover:bg-gray-100"
                    aria-label="Đóng"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
              </div>

              <div className="max-h-[55vh] overflow-y-auto px-4 pb-10 pt-3">
                {actions.length === 0 ? (
                  <p className="py-10 text-center text-[11px] font-bold uppercase tracking-wider text-gray-400">
                    Không có thao tác tạo mới
                  </p>
                ) : (
                  <div className="grid grid-cols-3 gap-2.5">
                    {actions.map((action) => {
                      const Icon = action.icon;
                      return (
                        <button
                          key={action.id}
                          type="button"
                          onClick={() => handleSelect(action.id)}
                          className="flex flex-col items-center gap-2 rounded-2xl border border-gray-100 bg-[#F8FAFC] px-2 py-3.5 text-center active:bg-red-50 active:border-red-100"
                        >
                          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-red-50 text-red-700">
                            <Icon size={22} />
                          </div>
                          <span className="line-clamp-2 text-[11px] font-black uppercase leading-tight tracking-wide text-gray-800">
                            {action.label}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <TaskRegisterModal
        isOpen={createKind === "task"}
        onClose={closeCreate}
        onSaved={closeCreate}
      />
      <OnLeaveCreateModal
        isOpen={createKind === "on_leave"}
        onClose={closeCreate}
        onSaved={closeCreate}
      />
      <OverTimeCreateModal
        isOpen={createKind === "overtime"}
        onClose={closeCreate}
        onSaved={closeCreate}
      />
      <BusinessTripCreateModal
        isOpen={createKind === "business_trip"}
        onClose={closeCreate}
        onSaved={closeCreate}
      />
      <AttendanceLogCreateModal
        isOpen={createKind === "attendance"}
        onClose={closeCreate}
        onSaved={closeCreate}
      />
    </>
  );
}
